"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPayout = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _jsMd = _interopRequireDefault(require("js-md5"));

var _payouts = require("@module/payouts");

var _request = _interopRequireDefault(require("@package/request"));

var _logger = require("@package/logger");

var _errors = require("@package/errors");

var _dialog = require("@package/dialog");

var notifications = _interopRequireWildcard(require("@package/notifications"));

var _utils = require("@package/utils");

var _slice = require("../slice");

var getCurrentUserName = function getCurrentUserName(state) {
  var _state$widgetProfile, _state$widgetProfile2, _state$widgetProfile3, _state$widgetProfile4, _name$;

  var name = (_state$widgetProfile = (_state$widgetProfile2 = state['widget/profile']) === null || _state$widgetProfile2 === void 0 ? void 0 : (_state$widgetProfile3 = _state$widgetProfile2['profile']) === null || _state$widgetProfile3 === void 0 ? void 0 : (_state$widgetProfile4 = _state$widgetProfile3['user']) === null || _state$widgetProfile4 === void 0 ? void 0 : _state$widgetProfile4['name']) !== null && _state$widgetProfile !== void 0 ? _state$widgetProfile : null;
  return Array.isArray(name) ? (_name$ = name[0]) !== null && _name$ !== void 0 ? _name$ : null : name;
};

var addUserNameDetail = function addUserNameDetail(details, userName) {
  var normalizedDetails = Array.isArray(details) ? details.filter(function (detail) {
    return detail && detail['name'] !== 'userName';
  }) : [];

  if (!userName) {
    return normalizedDetails;
  }

  return [].concat((0, _toConsumableArray2["default"])(normalizedDetails), [{
    name: 'userName',
    value: userName
  }]);
};

var createPayout = function createPayout(formData) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch, getState) {
      var userName, amount, details, payout, result, item, count, notExit, _yield$request, data;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Запрос на создание выплаты по id: ' + formData['externalId']
              });
              dispatch((0, _slice.createPayoutRequestAction)());
              userName = getCurrentUserName(getState());
              amount = formData['shop']['isShowCommissionCalculation'] ? formData['amount-credit'] : formData['amount'];
              details = addUserNameDetail([], userName);

              if (formData['recipientFullName'] && formData['recipientFullName'].replace(/^\s+|\s+$/g, '')) {
                details.push({
                  name: 'recipientFullName',
                  value: formData['recipientFullName'].replace(/^\s+|\s+$/g, '')
                });
              }

              payout = {
                amount: amount,
                externalId: formData['externalId'],
                currency: formData['account']['name'],
                description: formData['description'],
                paymentMethod: formData['method']['name'],
                details: details
              };

              if (formData['method']['name'] === 'Transfer') {
                payout['destination'] = String(formData['recipient']['id']);
                payout['shopId'] = formData['sender']['id'];
              } else {
                payout['destination'] = formData['destination'].replace(/^\s+|\s+$/g, '');
                payout['shopId'] = formData['shop']['id'];
              }

              if (formData['method']['name'] === 'BankCard') {
                if (formData['cardholder'] && formData['cardholder'].replace(/^\s+|\s+$/g, '')) {
                  payout['cardholder'] = formData['cardholder'].replace(/^\s+|\s+$/g, '');
                }
              }

              _context.next = 12;
              return (0, _request["default"])({
                url: '/payouts',
                method: 'post',
                data: payout
              });

            case 12:
              result = _context.sent;
              item = null;
              count = 0;
              notExit = true;

            case 16:
              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Опрос созданной выплаты по id: ' + result['data']['externalId']
              });
              ++count;
              _context.next = 20;
              return (0, _utils.sleep)(window.env['ATTEMPT_WAIT']);

            case 20:
              _context.next = 22;
              return (0, _request["default"])({
                url: "/payouts",
                method: 'get',
                params: {
                  externalId: result['data']['externalId']
                }
              });

            case 22:
              _yield$request = _context.sent;
              data = _yield$request.data;

              if (data.length > 0) {
                if (data[0]['externalId'] === result['data']['externalId']) {
                  if (data[0]['status']['code'] > 1 && data[0]['status']['code'] < 999) {
                    notExit = false;
                    item = data[0];
                  }
                }
              }

              if (!(count >= Number(window.env['ATTEMPT_COUNT']))) {
                _context.next = 27;
                break;
              }

              throw {
                data: {
                  code: '1.1.1'
                }
              };

            case 27:
              if (notExit) {
                _context.next = 16;
                break;
              }

            case 28:
              dispatch((0, _slice.createPayoutRequestSuccessAction)());
              dispatch((0, _payouts.createPayoutsRequestSuccessAction)(item));
              dispatch((0, _dialog.closeDialog)('create-payout'));

              if (result['data']['token2FA']) {
                (0, _logger.push)({
                  owner: 'Navigate',
                  message: 'Необходимо ввести TwoFA для подтверждения выплаты по id: ' + formData['externalId']
                });
                dispatch((0, _dialog.openDialog)('confirm-twoFA', {
                  id: item['id']
                }));
              } else {
                dispatch(notifications.push({
                  title: "\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
                  content: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u2116".concat(formData['externalId']),
                  mode: 'success',
                  autoClose: true
                }));
              }

              (0, _logger.push)({
                owner: 'Navigate',
                message: 'Выплата успешно создана по id: ' + formData['externalId']
              });
              _context.next = 42;
              break;

            case 35:
              _context.prev = 35;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 39;
                break;
              }

              return _context.abrupt("return", void 0);

            case 39:
              dispatch((0, _slice.createPayoutRequestFailAction)(_context.t0['data']));
              dispatch(notifications.pushFail(_context.t0['data']));
              (0, _logger.push)({
                owner: 'Navigate',
                level: 'error',
                message: 'Ошибка при создании выплаты по id: ' + formData['externalId']
              });

            case 42:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 35]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.createPayout = createPayout;